import { i18nNsFactory } from '@atlas-frontend/i18n';
import { ApiError, useMutationErrors } from '@atlas-frontend/sdk';
import translations from './useInputDataUploadErrors.translations.json';

const { addTranslations, t } = i18nNsFactory('input-data-upload-validation');
addTranslations(translations);

export const useInputDataUploadErrors = () => {
  const {
    mutationErrors: inputDataUploadErrors,
    setMutationErrors: setInputDataUploadErrors,
  } = useMutationErrors(
    (code, meta, path) => path ?? '',
    groupInputDataUploadErrors
  );

  return {
    inputDataUploadErrors,
    setInputDataUploadErrors,
  };
};

export const displayInputDataUploadErrorType = (name: string) =>
  t('alert.error.code.' + name.split('__')[0]);

const groupInputDataUploadErrors = (error: ApiError, i: number) => {
  return error.code + '__' + i;
};
